<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Sweet Alert</div>

                    <div class="card-body">
                        <div class="my-2">
                            <a
                                href="https://sweetalert2.github.io/"
                                target="_blank"
                                >Document</a
                            >
                        </div>
                        <div>
                            <button
                                class="btn btn-success"
                                @click="
                                    messageAlert(
                                        'success',
                                        'sweet alert success',
                                        'ใช้งาน sweet alert'
                                    )
                                "
                            >
                                Test Sweetalert success
                            </button>
                            <button
                                class="btn btn-danger"
                                @click="
                                    messageAlert(
                                        'error',
                                        'sweet alert error',
                                        'ใช้งาน sweet alert'
                                    )
                                "
                            >
                                Test Sweetalert Warning
                            </button>
                            <button
                                class="btn btn-warning"
                                @click="
                                    messageAlert(
                                        'warning',
                                        'sweet alert warning',
                                        'ใช้งาน sweet alert'
                                    )
                                "
                            >
                                Test Sweetalert error
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">vue-sortable-list</div>

                    <div class="card-body">
                        <div class="my-2">
                            <a
                                href="https://www.npmjs.com/package/vue-sortable-list"
                                target="_blank"
                                >Document</a
                            >
                        </div>
                        <ul class="list-group" v-draggable="{ value: items }">
                            <li
                                class="list-group-item"
                                v-for="item in items"
                                :key="item"
                            >
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">vue-sortable-list</div>

                    <div class="card-body">
                        <div class="my-2">
                            <a
                                href="https://www.npmjs.com/package/vue-drag-sortable"
                                target="_blank"
                                >Document</a
                            >
                            <div class="list list-group">
                                <sortable
                                    v-for="(item, index) in listData"
                                    v-model="dragData"
                                    :key="item"
                                    :index="index"
                                    class="list-group-item"
                                    @sortend="sortend($event, listData)"
                                    @real-click="click"
                                >
                                    Item {{ item.name }}
                                </sortable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sortable from "vue-drag-sortable";
export default {
    comonents: {
        Sortable
    },
    mounted() {
        console.log("Component mounted.");
    },
    data() {
        return {
            items: ["One", "Two", "Three", "Four", "Five", "Six", "Seven"],
            dragData: {},
            listData: [
                { name: "test", order: 1 },
                { name: "test1", order: 2 },
                { name: "test2", order: 3 },
                { name: "test3", order: 4 }
            ]
        };
    },
    methods: {
        click(e) {
            // Todo
        },
        sort(e) {
            const { oldIndex, newIndex } = e;
        },
        sortend(e, list) {
            const { oldIndex, newIndex } = e;
            this.rearrange(list, oldIndex, newIndex);
        },
        rearrange(array, oldIndex, newIndex) {
            if (oldIndex > newIndex) {
                array.splice(newIndex, 0, array[oldIndex]);
                array.splice(oldIndex + 1, 1);
            } else {
                array.splice(newIndex + 1, 0, array[oldIndex]);
                array.splice(oldIndex, 1);
            }
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.test {
    color: red;
}
.list {
    position: relative; /* position of list container must be set to `relative` */
}
/* dragging item will be added with a `dragging` class */
/* so you can use this class to define the appearance of it */
.list > *.dragging {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
    width: 100%;
}
</style>
